export default "__VITE_PUBLIC_ASSET__27627086__"